const CONTENT_ANALYSIS_API_URL = 'https://silo34.p7cloud.net/bs1.js';

export async function analyzeContent(url) {
	try {
		const params = new URLSearchParams({
			uri: url,
			_t: Date.now() // Cache-busting parameter
		});
		const response = await fetch(`${CONTENT_ANALYSIS_API_URL}?${params}`, {
			method: 'GET',
			mode: 'cors',
			credentials: 'omit', // Don't send cookies or auth headers
			cache: 'no-cache',
			headers: {
				// Minimal headers to avoid CloudFront cache key issues
				'Accept': 'application/json',
			},
		});

		// Check for server errors (500+)
		if (response.status >= 500) {
			throw new Error(`Server error: The content analysis service is temporarily unavailable. Please try again in a few moments.`);
		}

		// Check for other non-OK responses
		if (!response.ok) {
			let errorMessage = `Analysis failed (Status ${response.status})`;
			try {
				const errorData = await response.json();
				errorMessage = errorData.message || errorMessage;
			} catch {
				// If response isn't JSON, use the generic error message
			}
			throw new Error(errorMessage);
		}

		// Try to parse JSON response
		let data;
		try {
			data = await response.json();
		} catch (jsonError) {
			console.error('Failed to parse response as JSON:', jsonError);
			throw new Error('The content analysis service returned an invalid response. Please try again.');
		}

		console.log('Content Analysis API response:', data);

		return data;
	} catch (error) {
		// Re-throw with a user-friendly message if it's a network error
		if (error instanceof TypeError && error.message.includes('fetch')) {
			throw new Error('Unable to connect to the content analysis service. Please check your internet connection and try again.');
		}
		console.error('Content Analysis API Error:', error);
		throw error;
	}
}

export function validateUrl(url) {
	try {
		const urlObj = new URL(url);
		return urlObj.protocol === 'http:' || urlObj.protocol === 'https:';
	} catch {
		return false;
	}
}
